module.exports = __webpack_public_path__ + "static/media/chipsCollide2.3ec67a3b.mp3";